"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["label[_ngcontent-%COMP%]{margin-top:24px}.group[_ngcontent-%COMP%]{display:flex;gap:30px}.icon-close[_ngcontent-%COMP%]{cursor:pointer}.error-container[_ngcontent-%COMP%]{margin-top:24px}.error[_ngcontent-%COMP%]{color:#c00;font-size:12px;margin-top:4px}"];
exports.styles = styles;
